import React, { useState } from 'react';
import './QuestionReponse.css'; 
const QuestionReponse = ({ question, reponse }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleReponse = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="accordion-item plf">
            <div 
                className={`accordion-header ${isOpen ? 'open' : ''}`}
                onClick={toggleReponse}
            >
                <span className="question-text plf">{question}</span>
                <span className="toggle-icon">
                    {isOpen ? '−' : '+'}
                </span>
            </div>

            {isOpen && (
                <div className="accordion-content plf">
                    <p>{reponse}</p>
                </div>
            )}
        </div>
    );
};

export default QuestionReponse;